var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: function () {
            return _vm.toggleDropDownVisible(false)
          },
          expression: "() => toggleDropDownVisible(false)",
        },
      ],
      ref: "reference",
      staticClass: "dsf-dropdown-wrapper",
      on: {
        click: function () {
          return _vm.toggleDropDownVisible()
        },
      },
    },
    [
      _vm._t("default"),
      _c(
        "transition",
        {
          attrs: { name: "el-zoom-in-top" },
          on: { "after-leave": _vm.handleDropdownLeave },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.dropDownVisible,
                  expression: "dropDownVisible",
                },
              ],
              ref: "popper",
              staticClass: "el-popper dsf-dropdown-wrapper__dropdown",
              style: {
                width: _vm.width,
                "min-width": _vm.minWidth,
                height: _vm.height,
              },
            },
            [
              _vm.height && _vm.height !== "auto"
                ? _vm._t("dropdown")
                : _c(
                    "dsf-virtual-scroll",
                    { attrs: { "max-height": _vm.maxHeight, "scroll-x": "" } },
                    [_vm._t("dropdown")],
                    2
                  ),
            ],
            2
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }